import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Model from "@tripian/model";
import { api } from "@tripian/core";
import { saveNotification } from "../redux/action/user";

const useQuestionProfile = () => {
  const [loadingQuestionsProfile, setLoadingQuestionsProfile] =
    useState<boolean>(true);
  const [questionsProfile, setQuestionsProfile] = useState<Model.Question[]>();

  const dispatch = useDispatch();

  const fetchQuestionsProfile = useCallback(() => {
    setLoadingQuestionsProfile(true);
    return api
      .questionsProfile()
      .then((pQuestions: Model.Question[]) => {
        setQuestionsProfile(pQuestions);
      })

      .catch(questionsProfileError => {
        dispatch(
          saveNotification(
            Model.NOTIFICATION_TYPE.ERROR,
            "questionProfile",
            "Fetch Profile Questions",
            questionsProfileError
          )
        );
        throw questionsProfileError;
      })
      .finally(() => {
        setLoadingQuestionsProfile(false);
      });
  }, [dispatch]);

  useEffect(() => {
    fetchQuestionsProfile();
  }, [fetchQuestionsProfile]);

  // Re-fetch when the app language changes — questionsProfile() is cached per-lang
  // server-side, but this hook otherwise only ever fetches once on mount.
  useEffect(() => {
    const handleLanguageChange = () => {
      fetchQuestionsProfile();
    };
    window.addEventListener("languageChanged", handleLanguageChange);
    return () =>
      window.removeEventListener("languageChanged", handleLanguageChange);
  }, [fetchQuestionsProfile]);

  return { loadingQuestionsProfile, questionsProfile };
};

export default useQuestionProfile;
